<template>
  <CRow class="main py-5 mt-3">
    <CCol sm="8" class="py-5">
      <CRow>
        <CCol sm="12" class="d-flex flex-column">
          <div></div>
        </CCol>
      </CRow>
      <CRow class="mt-2">
        <CCol>
          <div class="d-flex justify-content-between border-b">
            <h3 class="font-weight-normal text-capitalize">{{ $t(titlePage) }}</h3>
            <CButton v-if="!isEditInvite && !isEditUser" :to="{ name: 'users-list' }" class="bg-gray-200 px-4 py-2">{{
              $t('settings.user.userInvite.button.cancel')
            }}</CButton>
            <CButton v-if="isEditInvite || isEditUser" class="bg-gray-200 px-4 py-2" @click="isEdit = !isEdit">
              {{ !isEdit ? $t('settings.user.userInvite.button.edit') : $t('settings.user.userInvite.button.cancel') }}
            </CButton>
          </div>
          <transition name="fade">
            <MenssageAlert :messages="messages" />
          </transition>
          <CRow>
            <CCol sm="6" class="d-flex flex-column">
              <div class="my-2 mt-4">
                <h4 class="font-weight-normal text-capitalize">{{ $t('settings.user.userInvite.header4.name') }}</h4>
                <CInput
                  style="max-width: 300px"
                  type="text"
                  class="my-4"
                  :readonly="isEditUser || editable"
                  :required="true"
                  placeholder="name"
                  :isValid="checkIfValid('userName')"
                  :invalidFeedback="assignInvalidFeedback($v.userName)"
                  v-model="$v.userName.$model"
                />
                <div></div>
              </div>
            </CCol>
            <CCol sm="6" class="d-flex flex-column">
              <div class="my-2 mt-4">
                <h4 class="font-weight-normal text-capitalize">{{ $t('settings.user.userInvite.header4.email') }}</h4>
                <CInput
                  style="max-width: 300px"
                  type="text"
                  class="my-4"
                  :readonly="isEditInvite || isEditUser"
                  :required="true"
                  :placeholder="$t('settings.user.userInvite.header4.email')"
                  :isValid="checkIfValid('userEmail')"
                  :invalidFeedback="assignInvalidFeedback($v.userEmail)"
                  v-model="$v.userEmail.$model"
                />
                <div></div>
              </div>
            </CCol>
          </CRow>

          <CRow>
            <CCol sm="6" class="d-flex flex-column">
              <div class="my-2">
                <h4 class="font-weight-normal text-capitalize">{{ $t('settings.user.userInvite.header4.profile') }}</h4>
                <v-select
                  style="max-width: 300px"
                  class="mb-0 no-close my-3"
                  :options="profileOptions"
                  :disabled="editable"
                  :isValid="checkIfValid('userProfile')"
                  :invalidFeedback="assignInvalidFeedback($v.userProfile)"
                  :placeholder="$t('settings.user.userInvite.select.profile-placeholder')"
                  v-model="$v.userProfile.$model"
                >
                </v-select>
                <div></div>
              </div>
            </CCol>
          </CRow>

          <div class="fd-flex finishArea">
            <CButton
              v-if="!isEditInvite && !isEditUser"
              color="primary"
              @click="sendInvite"
              class="mt-4 text-uppercase px-3 mb-5"
              :class="buttonClicked ? 'disabled' : false"
              :disabled="$v.$invalid"
              >{{ $t('settings.user.userInvite.button.send-invite') }}</CButton
            >

            <CButton
              v-if="isEditInvite"
              color="primary"
              @click="saveInvite"
              :disabled="editable"
              class="mt-4 text-uppercase px-5 mb-5"
              :class="buttonClicked ? 'disabled' : false"
              >{{ $t('settings.user.userInvite.button.save-invite') }}</CButton
            >

            <CButton
              v-if="isEditUser"
              color="primary"
              @click="saveUser"
              :disabled="editable"
              class="mt-4 text-uppercase px-5 mb-5"
              :class="buttonClicked ? 'disabled' : false"
              >{{ $t('settings.user.userInvite.button.save-user') }}</CButton
            >
          </div>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
import MaskedInput from 'vue-text-mask'
import services from '../user-services'
import MenssageAlert from '@/components/MenssageAlert'
import vSelect from 'vue-select'
import { getErrorMessage } from '@/utils/errorHandling.js'
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import { getInvalidFeedback } from '@/utils/vuelidate.js'

export default {
  name: 'UserInvite',
  components: {
    MaskedInput,
    MenssageAlert,
    vSelect,
  },
  mixins: [validationMixin],
  validations: {
    userName: {
      required,
      maxLength: maxLength(30),
    },
    userEmail: {
      required,
      email,
      maxLength: maxLength(255),
    },
    userProfile: {
      required,
    },
  },
  data() {
    return {
      titlePage: null,
      loading: false,
      messages: [],
      senderDomain: '',
      buttonClicked: false,
      userID: null,
      organizationId: null,
      userName: '',
      userProfile: '',
      userEmail: '',
      //profileOptions: [{label: 'Content Admin', value: 1}, {label: 'Super Admin', value: 2}, {label: 'Admin', value: 3}],
      items: [],
      isEditInvite: false,
      isEditUser: false,
      isEdit: false,
      defaultUser: {},
    }
  },
  mounted() {
    this.titlePage = 'settings.user.userInvite.header3.title' // Título Novo Invite por default

    if (this.$route.name === 'users-edit-invite') {
      this.titlePage = 'settings.user.userInvite.header3.title-edit-invite'
      this.isEditInvite = true
      if (!this.$route.params.inviteId) this.$router.go(-1)
    }

    if (this.$route.name === 'users-edit-user-organization') {
      this.titlePage = 'settings.user.userInvite.header3.title-edit-user'
      this.isEditUser = true
      if (!this.$route.params.userId) this.$router.go(-1)
    }

    this.userID = this.$store.state.auth.user.id
    this.organizationId = this.$store.state.auth.organizationId

    this.getRolesToInvite(() => {
      if (this.$route.name === 'users-edit-invite') {
        this.loadInvite(this.$route.params.inviteId)
      }

      if (this.$route.name === 'users-edit-user-organization') {
        this.loadUser(this.$route.params.userId)
      }
    })
  },
  computed: {
    profileOptions() {
      return this.items.map((item) => {
        return {
          label: item.name,
          value: item.roleId,
        }
      })
    },
    editable: function () {
      return (this.isEditInvite || this.isEditUser) && (this.isEditInvite || this.isEditUser) && !this.isEdit
    },
  },
  watch: {
    isEdit: function (newValue) {
      if (!newValue) {
        // Volta para os valores iniciais
        this.userName = this.defaultUser.userName
        this.userProfile = this.defaultUser.userProfile
        this.userEmail = this.defaultUser.userEmail
      }
    },
  },
  methods: {
    sendInvite() {
      this.messages = []
      this.buttonClicked = true

      let body = {
        organizationId: this.organizationId,
        userId: this.userID,
        inviteeEmail: this.userEmail,
        inviteeName: this.userName,
        roleId: this.userProfile.value,
      }

      services
        .createUserInvite(body)
        .then((response) => {
          this.$router.push({ name: 'users-list', params: { message: this.$t('settings.user.userInvite.messages.send-invite'), status: 'success' } })
          this.clean()
        })
        .catch((error) => {
          this.messages = [getErrorMessage(error?.response?.data)]
          this.buttonClicked = false
        })
        .finally(() => {
          this.buttonClicked = false
        })
    },

    getRolesToInvite(callback) {
      services
        .getRolesToInvite(this.organizationId)
        .then((response) => {
          this.items = response.data.data.items
        })
        .finally(() => {
          if (callback) {
            callback()
          }
        })
    },

    loadInvite(inviteId) {
      services.getInvite(inviteId).then((res) => {
        this.defaultUser = {
          userName: res.data.data.name,
          userEmail: res.data.data.email,
        }
        this.userName = res.data.data.name
        this.defaultUser.userProfile = this.userProfile = this.profileOptions.find((elm) => elm.value === res.data.data.roleId)
        this.userEmail = res.data.data.email
      })
    },

    loadUser(userId) {
      services.getOrganizationUser(this.$store.state.auth.organizationId, userId).then((res) => {
        this.defaultUser = {
          userName: res.data.data.name,
          userEmail: res.data.data.email,
        }

        this.userProfile = this.defaultUser.userProfile = this.profileOptions.find((elm) => elm.value === res.data.data.roleId)
        this.userName = res.data.data.name
        this.userEmail = res.data.data.email
      })
    },

    saveInvite() {
      this.buttonClicked = true
      let formData = {
        inviteeName: this.userName,
        roleId: this.userProfile.value,
      }
      this.messages = []

      services
        .updateInvite(this.$route.params.inviteId, formData)
        .then((response) => {
          this.$router.push({
            name: 'users-list',
            params: { message: this.$t('settings.user.userInvite.messages.invite-updated'), status: 'success' },
          })
          this.clean()
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: getErrorMessage(response.data.message) || 'Erro',
          })
          this.buttonClicked = false
        })
        .finally(() => {
          this.buttonClicked = false
        })
    },

    saveUser() {
      this.buttonClicked = true
      let formData = {
        roleId: this.userProfile.value,
      }
      this.messages = []
      let organizationId = this.$store.state.auth.organizationId

      services
        .updateUserOrganizationRole(organizationId, this.$route.params.userId, formData)
        .then((response) => {
          this.$router.push({ name: 'users-list', params: { message: this.$t('settings.user.userInvite.messages.user-updated'), status: 'success' } })
          this.clean()
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: this.$te(`general.errors.${response.data.Message}`) ? this.$t(`general.errors.${response.data.Message}`) : response.data.Message,
          })
          this.buttonClicked = false
        })
        .finally(() => {
          this.buttonClicked = false
        })
    },

    clean() {
      this.userName = ''
      this.userProfile = ''
      this.userEmail = ''
    },

    checkIfValid(fieldName) {
      const field = this.$v[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    assignInvalidFeedback(validationObj) {
      return getInvalidFeedback(validationObj)
    },
  },
}
</script>

<style lang="scss" scoped>
p {
  color: var(--gray-600);
}

.border-b {
  padding-bottom: 0.6rem;
  border-bottom: 1px solid var(--gray-500);
}
</style>

<style lang="scss">
.finishArea {
  .custom-control-label {
    padding-top: 5px;
    padding-left: 5px;
    color: var(--gray-600);
  }
}
</style>
